import PictureAsPdfSharpIcon from "@mui/icons-material/PictureAsPdfSharp";
import {
    AUTOCOMPLETE_FIELD_TYPE,
    DATE_RANGE_FIELD_TYPE,
    NUMERIC_RANGE_FIELD_TYPE,
    TEXT_FIELD_TYPE,
} from "../../helpers/constants";
import i18n from "../../i18n";
import DateService from "../../services/dateService";

export const EXAMPLE_TABLE_NAME = "example_table";

export const EXAMPLE_TABLE_FIELDS_CONFIG = [
    {
        name: "foo_number",
        getValueCallback: (rowData) => rowData.foo_number,
        label: i18n.t("table.example_table.foo_number"),
        filterType: TEXT_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => undefined,
        sortable: true,
    },
    {
        name: "product",
        getValueCallback: (rowData) => rowData.product,
        label: i18n.t("table.example_table.product"),
        filterType: AUTOCOMPLETE_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => ({
            options: filteringData?.value?.products,
            isObjectOption: true,
            optionLabelKey: "product_name",
            addNewValue: false,
            multiple: true,
            disableClearable: true,
            style: { minWidth: "150px" },
        }),
    },
    {
        name: "foo_date",
        getValueCallback: (rowData) =>
            DateService.convertDatetimeFromBackendToFormatYYYYMMDD(rowData.foo_date),
        label: i18n.t("table.example_table.foo_date"),
        filterType: DATE_RANGE_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => ({
            style: { minWidth: "100px" },
        }),
        sortable: true,
    },
    {
        name: "foo_value",
        getValueCallback: (rowData) => rowData.foo_value,
        label: i18n.t("table.example_table.foo_value"),
        filterType: NUMERIC_RANGE_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => ({
            style: { minWidth: "100px" },
            showNumberSeparator: true,
        }),
        sortable: true,
    },
    {
        name: "table_button",
        getValueCallback: (rowData, onClickButton) => {
            return <PictureAsPdfSharpIcon onClick={(e) => onClickButton(e, rowData.id)} />;
        },
        label: undefined,
        filterType: null,
    },
];
